import { FC } from 'react';
import { IonButton } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscription } from '@meraki-internal/state';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { UserState } from '../user/UserState';
import { CareMapState } from '../caremap/CareMapState';
import { buildGetHelpSurveyUrl } from './getHelpSurveyUrl';

export const GetHelpCard: FC = () => {
    const mixpanel = useInstance(MixPanelEventEmitter);

    const userState = useInstance(UserState);
    useSubscription(() => userState);

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const onClickGetHelp = () => {
        const caremap = careMapState.getMostRecentCaremap();

        const surveyUrl = buildGetHelpSurveyUrl({
            email: userState.state.email,
            firstName: userState.state.firstName,
            lastName: userState.state.lastName,
            caremap,
            source: 'card'
        });

        mixpanel.track('Get Help Experiment Opened', () => ({
            source: 'card',
            message: {
                title: 'Find the Right Care Support',
                description: 'Not sure where to start? Try Innerhive\'s hands-on help to find the care services best suited for you.'
            }
        }));

        window.open(surveyUrl, '_blank');
    };

    return (
        <Card padded data-type="get-help-card">
            <div style={{marginBottom: 12}}>
                <Text><b>Find the Right Care Support</b></Text>
            </div>

            <p>
                <Text type="detail">Not sure where to start? Try Innerhive's hands-on help to find the care services best suited for you.</Text>
            </p>

            <div style={{margin: '20px auto', maxWidth: 300, textAlign: 'center'}}>
                <IonButton
                    expand="block"
                    onClick={onClickGetHelp}
                    data-id="get-help-button"
                >
                    Get Recommendations
                </IonButton>
            </div>
        </Card>
    );
};
